
// import { useI18n } from '@/hooks/web/useI18n'
// const { t } = useI18n()
// import { useUserStore } from '@/store/modules/user'
// const unit = useUserStore().getUnit
// const unitSyb = useUserStore().getUnitSyb
// 格式化后台返回时间
// export const numberToTime = (data) => {
//   if (data === null || data === undefined) return ''
//   const hour = String(Math.floor(Number(data) / 100)).padStart(2, '0')
//   const min = String(Number(data) % 100).padStart(2, '0')
//   return `${hour}:${min}`
// }

// 把时间处理成数字给后台
// export const timeToNumber = (data) => {
//   if (typeof data === 'number') return data
//   const times = data.split(':')
//   const str = Number(times[0]) * 100 + Number(times[1])
//   return str
// }

// 保留小数最多2位 （小数位为0则不去除）
export const setToFixedWithoutZero = (value, decimal) => {
  if (value == null || value == undefined) value = 0
  if (isNaN(value)) return value
  const num = Number(value)
  const str = String(value)
  // 判断小数位数
  if (str.indexOf('.') === -1) {
    // 整数，直接返回
    return num
  }
  const decimalPart = str.split('.')[1] || ''
  // 如果是纯0小数（如100.00、200.000），返回整数
  if (/^\d+\.0+$/.test(str)) {
    return parseInt(num)
  }
  if (decimalPart.length === 1) {
    // 一位小数，保留一位，不补0
    return Number(num.toFixed(1))
  }
  if (decimalPart.length === 2) {
    // 二位小数，保留二位，不补0
    return Number(num.toFixed(2))
  }
  if (decimalPart.length >= 3) {
    // 两位及以上，按fixed(decimal)处理
    const d = typeof decimal === 'number' ? decimal : 3
    return Number(num.toFixed(d))
  }
  return num
}
// 保留小数
export const setToFixed = (value, decimal) => {
  if (value == null || value == undefined) value = 0
  if (isNaN(value)) return value
  const num = Number(value)
  // 判断小数位数
  // 两位及以上，按fixed(decimal)处理
  const d = typeof decimal === 'number' ? decimal : 3
  return num.toFixed(d)
}

//  加千分符
export const separator = (value, decimal) => {
  if (value == null || value == undefined) return '-'
  if (typeof Number(value) !== 'number') return value
  if (decimal != undefined && typeof decimal === 'number') value = setToFixed(value, decimal)
  value = value + ''
  if (!value.includes('.')) value += '.'
  return value
    .replace(/(\d)(?=(\d{3})+\.)/g, ($1) => {
      return $1 + ','
    })
    .replace(/\.$/, '')
}
// el-table 加千分符
export const setThousandSeparator = (row, column, value) => {
  return separator(value)
}

// el-table 加千分符
export const setSeparatorToFixed3 = (row, column, value) => {
  return separator(value, 3)
}
export const setSeparatorToFixed2 = (row, column, value) => {
  return separator(value, 2)
}


// 加货币符号
// export const preUnit = (value, decimal?) => {
//   if (value == null || value == undefined || value == '-') return '-'
//   if (decimal) value = separator(value, decimal)
//   return unitSyb + (value || 0)
// }

// // 加货币单位
// export const nextUnit = (value, decimal?) => {
//   if (value == null || value == undefined || value == '-') return '-'
//   if (decimal) value = separator(value, decimal)
//   return (value || 0) + unit
// }





/**
 * 将数字格式化为带单位（K/M）的简短形式，并可选添加货币符号与正负前缀
 * value 原始数值
 * symbol 可选货币符号，例如 '¥'、'$'。如果提供，则正数前加 '+'，负数前加 '-'
 * 格式化后的字符串，null/undefined 返回 '-'，非数字原样返回
 */
// export const numberToK = (value: number | string | null | undefined, symbol?: string) => {
//   if (value == null) return '-'

//   // 如果传入的是字符串且不能转换为数字，直接返回原值
//   const num = typeof value === 'string' ? Number(value) : value
//   if (isNaN(num)) return String(value)

//   const abs = Math.abs(num)
//   let formatted: string

//   // 根据大小决定单位
//   if (abs > 10_000_000) {
//     formatted = `${separator(abs / 1_000_000, 2)}M`
//   } else if (abs > 10_000) {
//     formatted = `${separator(abs / 1_000, 2)}K`
//   } else {
//     formatted = separator(num)
//   }

//   // 如果没传 symbol，直接返回
//   if (!symbol) return formatted

//   // 确定前缀 + 或 -
//   const prefix = num > 0 ? '+' : num < 0 ? '-' : ''
//   // 如果 formatted 已经带单位，则把符号与单位粘贴正确位置, 例如 "+¥1.23M"
//   return `${prefix}${symbol}${formatted.replace(/^[+-]?/, '')}`
// }

// 分钟处理时间显示
// export const formatMinute = (value) => {
//   if (value > 60) {
//     const hour = Math.trunc(value / 60)
//     const minute = Math.trunc(value % 60)
//     return hour + '' + t('common.hours') + minute + t('common.minute')
//   } else if (value > 0) {
//     return Math.trunc(value) + '' + t('common.minute')
//   } else {
//     return '0' + t('common.minute')
//   }
// }

// 小数转百分比
// export const percen = (value, num = 2) => {
//   if (typeof value == 'number') {
//     value = parseFloat((value * 100).toFixed(num))
//     return value + '%'
//   } else {
//     return '-'
//   }
// }

// el-table 加千分符
// export const setPercen = (row, column, value) => {
//   if (typeof value == 'number') {
//     return value + '%'
//   } else {
//     return '-'
//   }
// }
